import { memo } from 'react'
import { TableRow, TableCell, CircularProgress } from '@mui/material'

function TableLoadingRow({ colSpan = 8 }) {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} align="center" sx={{ py: 4 }}>
        <CircularProgress />
      </TableCell>
    </TableRow>
  )
}

export default memo(TableLoadingRow)
